import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import accountApi from './account/api'
import contactInfoApi from './contactInfo/api'

export const store = configureStore({
  reducer: {
    [accountApi.reducerPath]: accountApi.reducer,
    [contactInfoApi.reducerPath]: contactInfoApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([accountApi.middleware, contactInfoApi.middleware]),
  })

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch